/* eslint-disable prettier/prettier */
import { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';

type FormHeaderProps = {
  items: HeaderItem[];
  rightSlot?: ReactNode;
};

export type HeaderItem = {
  isSelected?: boolean;
  text: string | ReactNode; // ✅ Supports both plain text & JSX
  onClick?(): void;
};

export function FormHeader({ items, rightSlot }: FormHeaderProps) {
  return (
    <Stack
      sx={(theme) => ({
        backgroundColor: theme.palette.mode === 'dark' ? 'var(--app-tabs-bg)' : 'var(--app-tabs-bg)',
        borderRadius: '.5rem .5rem 0 0',
        position: 'relative',
        flexDirection: 'row',
      })}
    >
      {items.length > 1 &&
        items.map((item: HeaderItem) => (
          <Stack
            key={typeof item.text === 'string' ? item.text : 'header-item'}
            sx={(theme) => ({
              borderRadius: '.5rem .5rem 0 0',
              padding: '1.3rem 2rem',
              cursor: 'pointer',
              color: theme.palette.text.secondary,
              ...(item.isSelected && {
                color: theme.palette.primary.main,
                backgroundColor: theme.palette.background.paper,
              }),
            })}
            onClick={item.onClick}
          >
            {typeof item.text === 'string' ? (
              <Typography variant='body2' sx={{ fontWeight: 700 }}>
                {item.text}
              </Typography>
            ) : (
              item.text
            )}
          </Stack>
        ))}

      {items.length === 1 && (
        <Stack
          key={typeof items[0].text === 'string' ? items[0].text : 'header-single'}
          sx={(theme) => ({
            padding: '1.3rem 2rem',
            borderRadius: '.5rem .5rem 0 0',
            ...(items[0].isSelected && {
              color: theme.palette.primary.main,
              backgroundColor: theme.palette.background.paper,
            }),
          })}
        >
          {typeof items[0].text === 'string' ? (
            <Typography variant='body2' sx={{ fontWeight: 700 }}>
              {items[0].text}
            </Typography>
          ) : (
            items[0].text
          )}
        </Stack>
      )}

      {rightSlot && (
        <Stack
          direction='column'
          alignItems='center'
          justifyContent='center'
          sx={{
            height: '100%',
            position: 'absolute',
            insetInlineEnd: 0,
            top: 0,
            bottom: 0,
          }}
        >
          {rightSlot}
        </Stack>
      )}
    </Stack>
  );
}
